import { defaultMemoize } from 'reselect';
import { graphAxisLines, graphBackFill } from './';

// This pattern is used to define multiple other tokens so we're using defaultMemoize to increase performance.
export const graphWallFill = defaultMemoize((theme, parameters) => {
  return {
    ...graphAxisLines(theme, parameters),
    fillColor: graphBackFill(theme, parameters).fillColor,
    fillTransparency: 0,
    lineTransparency: 0,
    displayOpts: 'none',
    frameBorder: false
  };
});
//# sourceMappingURL=graphWallFill.js.map